import React from 'react';
import { StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { BodyText, Modal, TextLinkifyTags, theme } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

import { SweetpassCheckoutCta } from '../SweetpassCheckoutCta';

// ────────────────────────────────────────────────────────────────────────────────

export const SweetpassCheckoutFooter = (
  props: SweetpassCheckoutFooterProps,
) => {
  const { canCheckout, isLoading, handleCta } = props;

  const { t } = useLocalizationContext();
  const links = [
    {
      newTab: true,
      tag: 'terms',
      href: t('sweetpass-upgrade.confirm-modal.terms-url'),
      description: t('sweetpass.checkout.upgrade-cta-notice.terms-description'),
    },
  ];

  return (
    <SafeAreaView edges={['bottom']}>
      <Modal.Footer>
        <SweetpassCheckoutCta
          testID="sweetpass.checkout.cta-mobile"
          isLoading={isLoading}
          disabled={!canCheckout}
          onPress={handleCta}
        />

        <BodyText style={styles.upgradeNotice} size={5}>
          <TextLinkifyTags size={5} links={links}>
            {t('sweetpass.checkout.upgrade-cta-notice')}
          </TextLinkifyTags>
        </BodyText>
      </Modal.Footer>
    </SafeAreaView>
  );
};

// ─── Types ─────────────────────────────────────────────────────────────

type SweetpassCheckoutFooterProps = {
  readonly canCheckout: boolean;
  readonly isLoading: boolean;
  readonly handleCta: () => void;
};

// ─── Styles ────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  upgradeNotice: {
    paddingTop: theme.spacing['2'],
    textAlign: 'center',
    color: theme.colors.NEUTRAL_2,
  },
});
